<apx-chart
  [series]="properties.series"
  [chart]="properties.chart"
  [labels]="properties.labels"
  [fill]="properties.fill"
  [dataLabels]="properties.dataLabels"
  [responsive]="properties.responsive"
  [colors]="properties.colors"
  [title]="properties.title"
></apx-chart>